import React from "react";
import classNames from "classnames";
import { IconButton, Toolbar, Tooltip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { withStyles } from "@mui/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import AddUserIcon from "@mui/icons-material/Add";
import { withTranslation } from "react-i18next";

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.mode === "light"
      ? {
          color: "#4fc3f7",
          backgroundColor: "rgb(255, 234, 231)",
        }
      : {
          color: "#4fc3f7",
          backgroundColor: "rgb(255, 234, 231)",
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
  add: {
    backgroundColor: "#00a7e1",
    color: "#fff",
    transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    "&:hover": {
      backgroundColor: "#6cca98",
      color: "#fff",
    },
  },
});

const EnhancedToolbar = (props) => {
  const {
    TotalRowsSelected,
    openTaskManagerDialogClick,
    DeleteTaskClick,
    classes,
    t
  } = props;
  return (
    <Toolbar
      className={classNames(classes["root"], {
        [classes["highlight"]]: TotalRowsSelected > 0,
      })}
    >
      <Box component="div" classNames={classes["title"]} sx={{ width: "100%" }}>
        {TotalRowsSelected > 0 && (
          <Typography color="inherit" variant="subheading">
            {TotalRowsSelected} {t("Task.SelectedRow")}
          </Typography>
        )}
      </Box>
      <Box className={classes["spacer"]} />
      <Box
        className={classes["actions"]}
        sx={{ display: "flex", alignItems: "center", gap: 1 }}
      >
        {TotalRowsSelected === 1 || TotalRowsSelected > 1 ? (
          <Box>
            <Tooltip key="single-delete" title={t("Task.DeleteTooltip")}>
              <IconButton
                aria-label="Delete"
                onClick={DeleteTaskClick}
                sx={() => ({
                  "&:hover": { backgroundColor: "#6cca98", color: "#fff" },
                })}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Box>
        ) : (
          <Tooltip key="single-add" title={t("Task.AddTooltip")}>
            <IconButton
              aria-label="Add"
              className={classes["add"]}
              onClick={openTaskManagerDialogClick}
            >
              <AddUserIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Toolbar>
  );
};

export const EnhancedTableToolbar = withStyles(toolbarStyles, {
  withTheme: true,
})(withTranslation()(EnhancedToolbar));



// WEBPACK FOOTER //
// ./src/components/taskmanager/EnhancedTableToolbar.js